import React, { createContext, useState } from "react";
import InfoSnackbar from "../components/helpers/InfoSnackbar";

const InfoSnackbarContext = createContext();

const InfoSnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState(null);
  const [duration, setDuration] = useState(2000);
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: "top",
    horizontal: "center",
  });

  const alertError = (message) => {
    setSeverity("error");
    applyMessageAndOpen(message);
  };

  const alertInfo = (message) => {
    setSeverity("info");
    applyMessageAndOpen(message);
  };

  const alertSuccess = (message) => {
    setSeverity("success");
    applyMessageAndOpen(message);
  };

  const alertWarning = (message) => {
    setSeverity("warning");
    applyMessageAndOpen(message);
  };

  const applyMessageAndOpen = (message) => {
    setMessage(message);
    setOpen(true);
  };

  const onClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <InfoSnackbarContext.Provider
      value={{
        setDuration,
        setAnchorOrigin,
        alertError,
        alertInfo,
        alertSuccess,
        alertWarning,
      }}
    >
      <InfoSnackbar
        open={open}
        message={message}
        onClose={onClose}
        severity={severity}
        autoHideDuration={duration}
        anchorOrigin={anchorOrigin}
      />
      {children}
    </InfoSnackbarContext.Provider>
  );
};

export { InfoSnackbarProvider, InfoSnackbarContext };
